import { withInstall } from '@vuemap/vue-amap-util'
import Ellipse from './Ellipse.vue'

export const ElAmapEllipse = withInstall(Ellipse)
export default ElAmapEllipse
